import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function YoutubeIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_10640_68282)">
        <path
          d="M23.4982 5.98352C23.2217 4.95026 22.4096 4.13827 21.3764 3.86168C19.5055 3.35986 12 3.35986 12 3.35986C12 3.35986 4.49458 3.35986 2.62364 3.86168C1.59039 4.13827 0.778402 4.95026 0.501813 5.98352C1.50211e-07 7.85444 0 11.7603 0 11.7603C0 11.7603 1.50211e-07 15.6661 0.501813 17.5371C0.778402 18.5703 1.59039 19.3823 2.62364 19.6589C4.49458 20.1607 12 20.1607 12 20.1607C12 20.1607 19.5055 20.1607 21.3764 19.6589C22.4096 19.3823 23.2217 18.5703 23.4982 17.5371C24.0001 15.6661 24.0001 11.7603 24.0001 11.7603C24.0001 11.7603 23.9981 7.85444 23.4982 5.98352Z"
          fill="#FF0000"
        />
        <path
          d="M9.59766 15.3604L15.8328 11.7608L9.59766 8.16113V15.3604Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_10640_68282">
          <rect
            width="24"
            height="16.8008"
            fill="white"
            transform="translate(0 3.35986)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
